import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const GetServicesAndBundlesReport = async (startDate, endDate, serviceTypes, customerName, customerType, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {        
      const queryParams = {
        startDate: startDate || '',
        endDate: endDate || '',
        serviceTypes: serviceTypes || '',
        customerName: customerName || '',
        customerType: customerType || '',
      }
      // console.log(`${dev_baseUrl}/Reports/get-services-bundle-report?${queryParams}`)
      const response = await fetch(`${dev_baseUrl}/Reports/get-services-bundle-report`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(queryParams),
      });
      
      const data = await response.json();
      
      // Handle unauthorized
      if (!response.ok && data.statusCode === "Unauthorized") {
        navigate(`/login`);
        return []; // Return empty array on unauthorized
      }
      
      // Always return data.result or empty array
      if (response.ok && !data.isError && data.result) {
        return data.result; // Return the result array directly
      } else {
        // Return empty array for any error cases
        console.warn('API Error:', data.message);
        return [];
      }
    } catch (error) {
      console.error('Network error:', error);
      return []; // Return empty array on network error
    }
  } else {
    console.warn('Access token is not available.');
    navigate(`/login`);
    return []; // Return empty array when no token
  }
};